import React from "react";

import AuthDivider from "./components/AuthDivider";
import AuthFacebookButton from "./components/AuthFacebookButton";
import AuthFormLogin from "./components/AuthFormLogin";
import AuthLocaleSelect from "./components/AuthLocaleSelect/index";
import { getLoginFlow } from "../_utils/getLoginFlow";

const isBackoffice = window.location.href.includes("backoffice");

const AuthLogin = (
    <div className="segment__content__limited">
        {isBackoffice ? null : <AuthLocaleSelect />}
        <AuthFormLogin flow={getLoginFlow()} />
        <AuthDivider className="aph m-20-top m-30-bot" />
        <AuthFacebookButton className="aph m-15-top" buttonType="login" />
    </div>
);

export default AuthLogin;
